// Cover URL helpers — shared by grid/list views.
export const getAssetBaseUrl = () => window.location.origin;

export const getCoverUrl = (url) => {
  if (!url) return 'https://via.placeholder.com/192x288?text=No+Cover';
  if (url.startsWith('http')) return url;
  if (url.startsWith('/api')) return `${getAssetBaseUrl()}${url}`;
  return url;
};

// Small WebP thumbnail (~15-30 KB vs ~170 KB full size). Use in any
// grid/row that shows many covers at once. Falls back to the full image
// server-side if a thumbnail can't be generated.
export const getCoverThumbUrl = (url) => {
  const full = getCoverUrl(url);
  if (full.includes('/api/db-files/')) {
    return `${full}${full.includes('?') ? '&' : '?'}thumb=1`;
  }
  return full;
};

// Mid-size WebP (1280px, ~150-300 KB) for hero/detail views — replaces
// multi-MB original uploads without visible quality loss on screen.
export const getCoverDisplayUrl = (url) => {
  const full = getCoverUrl(url);
  if (full.includes('/api/db-files/')) {
    return `${full}${full.includes('?') ? '&' : '?'}display=1`;
  }
  return full;
};
